/// <reference types="google.maps" />
import { AddressPlaceDetails, toAddressPlaceDetails } from "./AddressQuestion";
import { getGoogleMapsGlobal } from "./useGoogleMapsScript";

/**
 * Resolves a stored address string to its parts, the way a pick would. Rejects
 * when Google finds nothing (`ZERO_RESULTS`) or the SDK is not loaded.
 */
export const geocodeAddress = async (
  address: string,
  country: string
): Promise<AddressPlaceDetails> => {
  const googleMaps = getGoogleMapsGlobal();
  if (!googleMaps) throw new Error("Google Maps is not loaded");

  const { results } = await new googleMaps.maps.Geocoder().geocode({
    address,
    componentRestrictions: { country },
  });

  return toAddressPlaceDetails(results[0], address);
};
